import {DialogTitle} from '@mui/material';
import {styled} from '@mui/material/styles';

import MuiModal from 'components/modal/Modal';

export const StyledModal = styled(MuiModal)(({theme}) => ({
  '.MuiPaper-root': {
    margin: theme.spacing('auto', 2),
    maxWidth: '100%',
    [theme.breakpoints.up('desktop')]: {
      margin: theme.spacing('auto', 4),
      maxWidth: theme.spacing(96)
    }
  },

  '.MuiDialogContent-root': {
    padding: 0
  }
}));

export const ModalContent = styled('div')(({theme}) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('tablet')]: {
    marginBottom: theme.spacing(1)
  },
  maxHeight: '44.25rem'
}));

export const StyledDialogTitle = styled(DialogTitle)(({theme}) => ({
  fontSize: '1.5rem',
  padding: theme.spacing(5, 2, 0, 2)
}));

export const StyledSection = styled('div')(({theme}) => ({
  fontSize: '0.8rem',
  color: theme.palette.grey[900],
  padding: theme.spacing(1, 0, 1, 0),
  '&:not(:last-child)': {
    borderBottom: `1px solid ${theme.palette.grey[100]}`
  }
}));

export const StyledDiscountDescription = styled('div')(() => ({
  maxWidth: '23.438rem',
  minWidth: '12rem'
}));
